import { useState } from 'react';
import type * as React from 'react';
import { useGarden } from '../../garden/GardenContext';
import type { GardenElement } from '../../garden/gardenReducer';
import { todayISO } from '../../utils/date';

interface BulkActionsPanelProps {
  elements: GardenElement[];
}

function BulkActionsPanel({ elements }: BulkActionsPanelProps) {
  const { selectedElementIds, deleteElements, addActionEntryBulk, clearSelection } = useGarden();
  const [date, setDate] = useState(todayISO());
  const [note, setNote] = useState('');

  function handleAdd(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!note.trim()) return;
    addActionEntryBulk(selectedElementIds, date, note.trim());
    setNote('');
  }

  return (
    <aside className="detail-panel detail-panel--bulk">
      <button type="button" className="detail-panel__close" onClick={clearSelection}>
        Close
      </button>
      <h2 className="detail-panel__bulk-title">{elements.length} elements selected</h2>
      <ul className="detail-panel__bulk-list">
        {elements.map((el) => (
          <li key={el.id}>{el.name}</li>
        ))}
      </ul>

      <button
        type="button"
        className="detail-panel__delete"
        onClick={() => deleteElements(selectedElementIds)}
      >
        Delete {elements.length} elements
      </button>

      <h3 className="detail-panel__bulk-subtitle">Add action-log entry to all selected</h3>
      <form className="detail-panel__bulk-form" onSubmit={handleAdd}>
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="action-log__date-input"
        />
        <input
          type="text"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="e.g. Fertilized"
          className="action-log__note-input"
        />
        <button type="submit">Add to {elements.length}</button>
      </form>
    </aside>
  );
}

export default BulkActionsPanel;
